import _extends from "@babel/runtime/helpers/extends";
import { Box, Divider, Text, TextButton } from '@wix/design-system';
import { CycleUtils, EllipsisForTrans, getSearchParams } from '@wix/package-picker-shared';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import { Dismiss } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useCurrentModule } from '../ModuleProvider';
import s from './CycleSelectorDisabledFeatures.scss';
export const CycleSelectorDisabledFeatures = _ref => {
  let {
    productId,
    mobile = false
  } = _ref;
  const module = useCurrentModule();
  const {
    domainName
  } = getSearchParams();
  const {
    data
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchMonthlyDisabledFeatures({
    productId
  }, Boolean(productId));
  const disabledFeatures = (data == null ? void 0 : data.disabledFeatures) ?? [];
  const {
    Trans
  } = module.internals.useTranslations();
  const title = /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.monthly_disclaimer.note",
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "normal"
    })]
  });
  const linkProps = mobile ? {
    skin: 'dark',
    weight: 'normal',
    underline: 'always'
  } : {};
  return /*#__PURE__*/React.createElement(Box, {
    borderRadius: "6px",
    direction: "vertical",
    gap: mobile ? 'SP2' : 'SP3'
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    dataHook: "title-wrapper",
    className: mobile ? undefined : s.noteWrapper
  }, title), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: mobile ? 'SP2' : 'SP1'
  }, disabledFeatures.map(feature => {
    var _feature$content;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      verticalAlign: "middle",
      gap: mobile ? 'SP1' : 'SP2'
    }, /*#__PURE__*/React.createElement(Dismiss, {
      color: mobile ? '#44485F' : '#C8C7CC',
      size: mobile ? '18px' : '20px'
    }), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: (_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey,
      values: {
        domainName
      },
      components: {
        ellipsis: /*#__PURE__*/React.createElement(EllipsisForTrans, {
          maxWidth: 160
        })
      }
    })));
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.monthly_disclaimer.footer",
    components: {
      1: /*#__PURE__*/React.createElement(TextButton, _extends({
        size: "small"
      }, linkProps, {
        onClick: e => {
          e.stopPropagation();
          module.internals.bi.onMonthlyCycleSectionHelperLinkClick == null || module.internals.bi.onMonthlyCycleSectionHelperLinkClick({
            action: 'select-1year-cycle'
          });
          module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId({
            cycleType: PurchaseOffering.CycleType.RECURRING,
            cycleDuration: {
              unit: PurchaseOffering.DurationUnit.YEAR,
              count: 1
            }
          }));
        }
      })),
      3: /*#__PURE__*/React.createElement(TextButton, _extends({
        size: "small"
      }, linkProps, {
        onClick: e => {
          e.stopPropagation();
          module.internals.bi.onMonthlyCycleSectionHelperLinkClick == null || module.internals.bi.onMonthlyCycleSectionHelperLinkClick({
            action: 'select-2year-cycle'
          });
          module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId({
            cycleType: PurchaseOffering.CycleType.RECURRING,
            cycleDuration: {
              unit: PurchaseOffering.DurationUnit.YEAR,
              count: 2
            }
          }));
        }
      }))
    }
  })));
};
//# sourceMappingURL=CycleSelectorDisabledFeatures.js.map